import { patientComplianceAnalyticAction } from "../actions/patientComplianceAnalyticAction";

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  accountFilter: "all",
  yearlyFilter: "current_year",
};

const patientComplianceAnalyticSlice = createSlice({
  name: "patientComplianceAnalytic",
  initialState: initialState,
  reducers: patientComplianceAnalyticAction,
});

export const { changeFilter } = patientComplianceAnalyticSlice.actions;

export default patientComplianceAnalyticSlice.reducer;
